import { SortDirection } from 'src/apis/api-utilities';
import {
  InvoicesSortBy,
  InvoicesStatus,
  InvoiceType,
  MonthlyStatementType,
} from 'src/apis/capacity-management/types';
import { ContractSuggestion } from 'src/pages/reporting/monthly-statements/corrections/contracts-suggestions-input';
import { TsoSuggestion } from 'src/pages/reporting/my-transactions/tso-suggestions-input';
import * as pp from 'src/utils/page-params';

export function usePageParams() {
  return pp.usePageParams(
    pp
      .configure()
      .add(pp.start('start'))
      .add(pp.number('pageSize').default(10))
      .add(pp.param('sortBy').default<InvoicesSortBy>('CREATION_DATE'))
      .add(pp.param('sortDirection').default<SortDirection>('desc'))
      .add(pp.param('creationDateStart').filter({ label: 'Created on' }))
      .add(pp.param('creationDateEnd').filter({ label: 'Created on' }))
      .add(pp.param('invoiceNumber').filter({ label: 'Invoice Number' }))
      .add(pp.param('dueDateStart').filter({ label: 'Due Date' }))
      .add(pp.param('dueDateEnd').filter({ label: 'Due Date' }))
      .add(
        pp
          .list('tsoId')
          .deserialize<TsoSuggestion>(JSON.parse)
          .serialize(JSON.stringify)
          .filter({ label: 'TSO' })
      )
      .add(
        pp
          .list('contractId')
          .deserialize<ContractSuggestion>(JSON.parse)
          .serialize(JSON.stringify)
          .filter({ label: 'Contract' })
      )
      .add(
        pp
          .list('status')
          .cast<InvoicesStatus>()
          .filter({ label: 'Invoice Status' })
      )
      .add(
        pp
          .list('invoiceType')
          .cast<InvoiceType>()
          .filter({ label: 'Invoice Type' })
      )
      .add(
        pp
          .list('monthlyStatementType')
          .cast<MonthlyStatementType>()
          .filter({ label: 'Capacity / Commodity Invoice' })
      )
      .add(
        pp
          .param('onlyOverdue')
          .default(false)
          .filter({ label: 'Overdue Status' })
      )
  );
}

export type PageParams = ReturnType<typeof usePageParams>;
